import React, { useRef, useState } from "react";
import portfolioPhoto from "../../assets/images/taro112.png";
import "./FeelingProud.css";

function FeelingProud() {
  const wrapperRef = useRef(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0, active: false });

  const handleMouseMove = (event) => {
    const el = wrapperRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = (event.clientX - rect.left) / rect.width;
    const py = (event.clientY - rect.top) / rect.height;
    // Map pointer to rotateY / rotateX (max ~12deg)
    setTilt({
      x: (0.5 - py) * 22,
      y: (px - 0.5) * 22,
      active: true,
    });
  };

  const handleMouseLeave = () => {
    setTilt({ x: 0, y: 0, active: false });
  };

  return (
    <div
      ref={wrapperRef}
      className={`greeting-profile-wrapper${tilt.active ? " is-tilting" : ""}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg) scale(${
          tilt.active ? 1.04 : 1
        })`,
      }}
    >
      <img
        className="greeting-profile-halo"
        src={portfolioPhoto}
        alt=""
        aria-hidden="true"
      />
      <img
        className="greeting-profile-photo"
        src={portfolioPhoto}
        alt="portfolio-profile"
      />
      <div
        className="greeting-profile-glare"
        style={{
          opacity: tilt.active ? 0.35 : 0,
          background: `radial-gradient(
            circle at ${50 + tilt.y * 2}% ${50 - tilt.x * 2}%,
            rgba(255,255,255,0.55) 0%,
            transparent 55%
          )`,
        }}
      />
    </div>
  );
}

export default FeelingProud;
